export default [
    {
      name: "grid",
      type: "Texture",
      path: "./textures/texture_landscape.png",
    }
]; 